/**
 * O módulo do 2 Pra 500 volta a ficar cadastrado como '2 para 500' em
 * `modulos.nome`, porque o app em campo decide exibir a modalidade com
 * `modules.includes('2 para 500')` e não será atualizado.
 *
 * 'Bilhetinho' continua aceito aqui: o rename chegou a rodar e pode estar
 * gravado no `usuario.modulos` do localStorage até o próximo login.
 */
export const MODULO_2_PRA_500 = '2 para 500';

export const MODULOS_2_PRA_500 = [MODULO_2_PRA_500, 'Bilhetinho'];

export const temModulo2Pra500 = (modulos) =>
    Array.isArray(modulos) && MODULOS_2_PRA_500.some((nome) => modulos.includes(nome));
